import { render } from "./MediaPredict.vue?vue&type=template&id=87cf01ce&scoped=true"
import script from "./MediaPredict.vue?vue&type=script&lang=js"
export * from "./MediaPredict.vue?vue&type=script&lang=js"

import "./MediaPredict.vue?vue&type=style&index=0&id=87cf01ce&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87cf01ce"]])

export default __exports__